import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { apiFetch } from "../api/client";
import "./TdHost.css";

/**
 * TD Server IP — the OSC target the backend sends joystick/tap data to.
 * Stored in the td_server_ip table; the backend reads it once at boot, so
 * a change here needs a backend restart to take effect.
 */
export default function TdHost() {
  const [current, setCurrent] = useState(null);
  const [host, setHost] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null); // { ok: boolean, text: string }

  const load = async () => {
    try {
      const r = await apiFetch("/api/admin/td-host");
      setCurrent(r.host || null);
      setHost(r.host?.host || "");
      setName(r.host?.name || "");
    } catch (e) {
      setMsg({ ok: false, text: e.message });
    }
  };

  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy(true);
    setMsg(null);
    try {
      await apiFetch("/api/admin/td-host", {
        method: "PUT",
        body: JSON.stringify({ host: host.trim(), name: name.trim() }),
      });
      setMsg({
        ok: true,
        text: "저장되었습니다. OSC 송신에 즉시 반영하려면 백엔드를 재시작하세요.",
      });
      await load();
    } catch (e) {
      setMsg({ ok: false, text: e.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout title="TD 서버 IP">
      <div className="tdhost">
        <div className="tdhost-current">
          현재 TD Host : <b>{current?.host || "(미설정)"}</b>
          {current?.name ? ` · ${current.name}` : ""}
        </div>

        <div className="tdhost-note">
          백엔드가 OSC(조이스틱·탭)를 보내는 TouchDesigner PC의 IP입니다.
          여기 값이 있으면 backend/.env 의 TD_HOST 보다 우선합니다.
        </div>

        <div className="tdhost-field">
          <label>TD Host IP</label>
          <input
            className="input"
            value={host}
            onChange={(e) => setHost(e.target.value)}
            placeholder="192.168.0.126"
          />
        </div>

        <div className="tdhost-field">
          <label>이름 (선택)</label>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="TD_MAIN"
          />
        </div>

        <button className="btn btn-primary" onClick={save} disabled={busy || !host.trim()}>
          {busy ? "저장 중…" : "저장"}
        </button>

        {msg && (
          <div className={`tdhost-msg ${msg.ok ? "ok" : "err"}`}>{msg.text}</div>
        )}
      </div>
    </Layout>
  );
}
